import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";

const ProtectedRoute = ({ children, adminOnly = false, redirectTo = "/login", unauthorizedRedirect = "/" }) => {
  const { user, loading } = useUser();

  if (loading) return null; // Or a loader

  // 1. Check if user is logged in at all
  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  // 2. If it's an admin-only route, verify dashboard logout state & roles
  if (adminOnly) {
    const isDashboardLoggedOut = localStorage.getItem('ar_dashboard_logged_out') === 'true';
    if (isDashboardLoggedOut) {
      return <Navigate to="/dashboard/login" replace />;
    }

    // Normalize user roles from array, string, or user.role
    const rawRoles = user.roles || user.role || [];
    const userRoles = Array.isArray(rawRoles)
      ? rawRoles
      : typeof rawRoles === "string"
        ? rawRoles.split(",").map(r => r.trim())
        : [];

    const allowedStaffRoles = ["admin", "super admin"];

    // Check by role name (case-insensitive)
    let hasAdminPrivileges = userRoles.some(role =>
      allowedStaffRoles.includes(String(role).trim().toLowerCase())
    );

    // Also check known admin emails as fallback safeguard
    const knownAdminEmails = [
      "arinfotechsolutions38@gmail.com",
      "sales@arinfotechsolutions.com",
      "admin@arinfotechsolutions.com",
      "admin@arinfotech.com",
      "admin@coldpressedoils.in"
    ];
    if (!hasAdminPrivileges && user.email && knownAdminEmails.includes(user.email.toLowerCase())) {
      hasAdminPrivileges = true;
    }

    if (!hasAdminPrivileges) {
      console.warn("Unauthorized access attempt to dashboard by non-admin user:", user);
      return <Navigate to={unauthorizedRedirect} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
